import { useUserStore } from '@/stores';

export type ResponseDetailLevel = 'single_sentence' | 'concise' | 'medium' | 'detailed';

export const RESPONSE_DETAIL_OPTIONS = [
  { value: 'single_sentence' as ResponseDetailLevel, label: 'Single Sentence', description: 'One sentence response' },
  { value: 'concise' as ResponseDetailLevel, label: 'Concise', description: 'Brief, to-the-point responses' },
  { value: 'medium' as ResponseDetailLevel, label: 'Medium', description: 'Balanced detail level' },
  { value: 'detailed' as ResponseDetailLevel, label: 'Detailed', description: 'Comprehensive, in-depth responses' },
];

export function useResponseDetailLevel() {
  const responseDetailLevel = useUserStore(state =>
    state.userSettings.responseDetailLevel || 'medium'
  );
  const updateUserSettings = useUserStore(state => state.updateUserSettings);

  const setResponseDetailLevel = (value: ResponseDetailLevel) => {
    updateUserSettings('responseDetailLevel', value);
  };

  return { responseDetailLevel, setResponseDetailLevel };
}
